import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type DatabaseViewFieldFragment = { label?: string | null, width: number, fieldId: string, visible: boolean, required: boolean, description?: string | null, placeholder?: string | null, textType?: Types.DatabaseTextFormatEnum | null, allowCustomOptions?: boolean | null, descriptionEnabled?: boolean | null, minLabel?: string | null, maxLabel?: string | null };


export type DatabaseViewFieldFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const DatabaseViewFieldFragmentDoc = /*#__PURE__*/ gql`
    fragment DatabaseViewField on DatabaseViewFieldType {
  label
  width
  fieldId
  visible
  required
  description
  placeholder
  textType
  allowCustomOptions
  descriptionEnabled
  minLabel
  maxLabel
}
    `;